import type { BulkReferralRowResult } from '../../../../types/bulk-referral.type';
import { ReconciliationTableRow } from './ReconciliationTableRow';

type ReconciliationTableProps = {
  rows: BulkReferralRowResult[];
  selectedRowNumber: number | null;
  flashingRowNumber: number | null;
  onSelectRow: (row: BulkReferralRowResult) => void;
};

const COLUMNS = ['Row', 'Referring', 'Referred', 'On behalf of', 'Care seeker', 'Date', 'Status', 'Problem'];

export const ReconciliationTable = ({ rows, selectedRowNumber, flashingRowNumber, onSelectRow }: ReconciliationTableProps) => (
  <div className="min-w-0 flex-1 overflow-auto">
    <table className="w-full table-fixed">
      <thead className="sticky top-0 z-10 bg-white shadow-[0_1px_0_rgba(0,0,0,0.06)]">
        <tr className="text-left text-xs font-medium uppercase tracking-wide text-gray-400">
          {COLUMNS.map((column) => (
            <th key={column} className="px-3 py-2">
              {column}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <ReconciliationTableRow
            key={row.rowNumber}
            row={row}
            isSelected={selectedRowNumber === row.rowNumber}
            isFlashing={flashingRowNumber === row.rowNumber}
            onSelect={() => onSelectRow(row)}
          />
        ))}
      </tbody>
    </table>
  </div>
);
